import CauzeSpinner from 'components/CauzeSpinner/CauzeSpinner';

const LoadingView = () => {
  return <CauzeSpinner fullscreen />;
};

export default LoadingView;
